import { render, staticRenderFns } from "./vfg-field-custom-monthpicker.vue?vue&type=template&id=12791fab"
import script from "./vfg-field-custom-monthpicker.vue?vue&type=script&lang=js"
export * from "./vfg-field-custom-monthpicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports